import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import user from './user';
import glossary from './glossary';

const reducer = combineReducers({ user, glossary });

const store = configureStore({
	reducer,
	// eslint-disable-next-line no-undef
	// devTools: process.env.REACT_APP_API_IS_DEV === 'false' ? false : true,
	devTools: true,
});

export default store;
